import { render, staticRenderFns } from "./SingleTagInput.vue?vue&type=template&id=100c069e&scoped=true"
import script from "./SingleTagInput.vue?vue&type=script&lang=js"
export * from "./SingleTagInput.vue?vue&type=script&lang=js"
import style0 from "./SingleTagInput.vue?vue&type=style&index=0&id=100c069e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100c069e",
  null
  
)

export default component.exports